module.exports = __webpack_public_path__ + "img/caret-up.03a914c6.svg";